import { REVIEW_PAGE_SIZE } from '~/features/program/constants';

/**
 * Re-exported so callers page in the same units the reviews endpoint returns.
 * Defining a second copy here risks drifting from `getProgramReviews`.
 */
export { REVIEW_PAGE_SIZE };

export function getReviewsTotalPages(numberOfReviews: number, pageSize: number = REVIEW_PAGE_SIZE): number {
  return Math.max(1, Math.ceil(numberOfReviews / pageSize));
}
